<template>
  <div class="contaier">
    <!-- <page-header></page-header> -->
    <div class="max-box title-area">
      <div class="hq-title1">
        {{ carInfo.title }} {{ $t('public.configuration') }}
      </div>
      <div class="attentions">
        <span class="attention">{{ $t('public.note') }}：</span>
        <div class="icon-standard">●</div>
        <span class="iconspan">{{ $t('public.standard') }}</span>
        <div class="icon-selection">O</div>
        <span class="iconspan">{{ $t('public.standard1') }}</span>
        <div class="icon-unuse">—</div>
        <span class="iconspan">{{ $t('public.standard3') }}</span>
      </div>
    </div>

    <div class="max-box config-page-container">
      <!-- 左侧导航 -->
      <div class="left-nav">
        <div class="nav-scroll">
          <div
            :key="idx"
            class="nav-item"
            :class="{ active: activeIndex === idx }"
            v-for="(item, idx) in vehicleConfig"
            @click="scrollToGroup(idx)">
            {{ langShow(item.t) }}
          </div>
        </div>
      </div>

      <!-- 右侧配置表 -->
      <div class="right-content" ref="rightContent">
        <!-- 表格整体（表头+内容共用一个横向滚动容器，列自然对齐） -->
        <div class="table-wrapper" ref="tableWrapper">
          <!-- 表头行 -->
          <div class="table-header-sticky" ref="tableHeader">
            <div class="grid-row">
              <div
                :key="item.id"
                class="cell name-cell"
                :class="{ 'cell-top': index === 0 }"
                v-for="(item, index) in carInfo.lArr">
                <!-- {{ item.car }} -->
                {{ langShow(item.t) }}
              </div>
              <!-- <div class="cell">Executive</div>
              <div class="cell active">Deluxe</div>
              <div class="cell">Flagship</div>
              <div class="cell">Long Range</div> -->
            </div>
          </div>

          <!-- 分组列表 → 每个标题自动吸顶 -->
          <div class="group-list">
            <div
              class="group-item"
              v-for="(group, idx) in vehicleConfig"
              :key="idx"
              :ref="el => setGroupRef(el, idx)">
              <!-- 分组标题行（融入 grid 体系，第一列 sticky-left 和 name-cell 一致） -->
              <div class="grid-row group-title-row">
                <div class="cell name-cell group-title-cell">
                  <!-- {{ group.title }}3 -->
                  {{ langShow(group.t) }}
                </div>
              </div>
              <!-- 配置行 -->
              <div
                class="grid-row"
                v-for="(item, rdx) in group.items"
                :key="rdx">
                <div class="cell name-cell">{{ langShow(item.t) }}</div>
                <!-- <div class="cell name-cell">{{ item.name }}</div> -->
                <div class="cell">{{ item.v1 }}</div>
                <div class="cell active">{{ item.v2 }}</div>
                <template v-if="id == 1">
                  <div class="cell">{{ item.v3 }}</div>
                  <div class="cell">{{ item.v4 }}</div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer-page></footer-page>
  </div>
</template>
<script>
import {
  modelPropParameterApi,
  // modelListApi,
} from '@/Api/requestApi'
import { carInfo } from '@/assets/js/static2'
// import PageHeader from '@/components/PageHeader.vue'
import FooterPage from '@/components/FooterPage.vue'
export default {
  name: 'ParamDetails',
  components: {
    // PageHeader,
    FooterPage,
  },
  data() {
    return {
      carInfo: {},
      vehicleConfig: [],
      vehicleConfig2: [],
      activeIndex: 0,
      groupRefs: [],
      isHeaderFixed: false,
      currentFixedGroupIndex: -1,
      id: 1,
      carConfigData: [],
    }
  },
  mounted() {
    // if (false) {
    this.id = this.$route.query.id
    if (this.$route.query.id == 1) {
      console.log('11111 :>> ', 11111)
      this.carInfo = carInfo[1]
      // this.vehicleConfig = vehicleConfig
    } else {
      console.log('2222222 :>> ', 2222222)
      this.carInfo = carInfo[2]
      // this.vehicleConfig = vehicleConfig2
    }
    this.modelParameterFn()
    this.$nextTick(() => {
      if (window.innerWidth <= 768) {
        window.addEventListener('scroll', this.onMobileScroll, {
          passive: true,
        })
        window.addEventListener('resize', this.onMobileScroll)
        if (this.$refs.tableWrapper) {
          this.$refs.tableWrapper.addEventListener(
            'scroll',
            this.syncFixedHeader
          )
        }
        this.fixHeaderIfNeeded()
      }
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onMobileScroll)
    window.removeEventListener('resize', this.onMobileScroll)
    if (this.$refs.tableWrapper) {
      this.$refs.tableWrapper.removeEventListener(
        'scroll',
        this.syncFixedHeader
      )
    }
    if (this._headerClone) {
      this._headerClone.removeEventListener('scroll', this.syncWrapperFromClone)
      this._headerClone.remove()
      this._headerClone = null
    }
    if (this._groupTitleClone) {
      if (this._groupTitleClone._onScroll) {
        this._groupTitleClone.removeEventListener(
          'scroll',
          this._groupTitleClone._onScroll
        )
      }
      this._groupTitleClone.remove()
      this._groupTitleClone = null
    }
  },
  methods: {
    // 统一处理：导航 active 跟踪 + 表头 fixed 切换 + 分组标题吸顶
    onMobileScroll() {
      if (window.innerWidth > 768) {
        // 切换回桌面端：清理所有移动端 fixed clone
        this._cleanupDesktopSwitch()
        return
      }
      this.trackActiveNav()
      this.fixHeaderIfNeeded()
      this.fixGroupTitleIfNeeded()
    },
    // 桌面端清理：移除 fixed clone，恢复原表头可见
    _cleanupDesktopSwitch() {
      if (this.isHeaderFixed) {
        this.isHeaderFixed = false
        const th = this.$refs.tableHeader
        if (th) th.style.visibility = ''
        if (this._headerClone) {
          this._headerClone.removeEventListener(
            'scroll',
            this.syncWrapperFromClone
          )
          this._headerClone.remove()
          this._headerClone = null
        }
      }
      this._removeGroupTitleClone()
    },
    // 导航 active 跟踪
    trackActiveNav() {
      const groups = this.groupRefs
      if (!groups || groups.length === 0) return
      const viewTop = window.pageYOffset + 158
      let activeIdx = 0
      for (let i = groups.length - 1; i >= 0; i--) {
        if (groups[i] && groups[i].getBoundingClientRect) {
          const top = groups[i].getBoundingClientRect().top + window.pageYOffset
          if (top <= viewTop + 20) {
            activeIdx = i
            break
          }
        }
      }
      if (this.activeIndex !== activeIdx) {
        this.activeIndex = activeIdx
      }
    },
    // 表头吸附：克隆镜像 fixed 到 body，原表头 visibility:hidden 占位避免内容跳动
    fixHeaderIfNeeded() {
      const tw = this.$refs.tableWrapper
      const th = this.$refs.tableHeader
      if (!tw || !th) return
      const twRect = tw.getBoundingClientRect()
      const FIX_TOP = 112
      const HEADER_H = 46
      const needFix = twRect.top < FIX_TOP && twRect.bottom > FIX_TOP + HEADER_H
      if (needFix && !this.isHeaderFixed) {
        this.isHeaderFixed = true
        // 隐藏原表头保留占位
        th.style.visibility = 'hidden'
        // 克隆表头节点固定到 body
        const clone = th.cloneNode(true)
        clone.style.position = 'fixed'
        clone.style.top = FIX_TOP + 'px'
        clone.style.left = twRect.left + 'px'
        clone.style.width = tw.clientWidth + 'px'
        clone.style.zIndex = '10'
        clone.style.overflowX = 'auto'
        clone.style.whiteSpace = 'nowrap'
        clone.style.background = '#f7f7f7'
        clone.style.display = ''
        clone.style.visibility = 'visible'
        clone.scrollLeft = tw.scrollLeft
        // 双向横滚同步：clone 滚动时也同步回 wrapper
        clone.addEventListener('scroll', this.syncWrapperFromClone)
        document.body.appendChild(clone)
        this._headerClone = clone
      } else if (!needFix && this.isHeaderFixed) {
        this.isHeaderFixed = false
        th.style.visibility = ''
        if (this._headerClone) {
          this._headerClone.removeEventListener(
            'scroll',
            this.syncWrapperFromClone
          )
          this._headerClone.remove()
          this._headerClone = null
        }
      } else if (this.isHeaderFixed && this._headerClone) {
        this._headerClone.style.left = twRect.left + 'px'
        this._headerClone.style.width = tw.clientWidth + 'px'
      }
    },
    // 横滚同步：wrapper.scrollLeft → 所有 fixed clone.scrollLeft + 分组标题 translateX 固左
    syncFixedHeader() {
      const tw = this.$refs.tableWrapper
      if (!tw) return
      const sl = tw.scrollLeft
      if (this.isHeaderFixed && this._headerClone) {
        this._headerClone.scrollLeft = sl
      }
      // 分组标题 JS 固左：inline position:sticky（在 mounted 中已设，此处不重复设置）
      if (this._groupTitleClone) {
        this._groupTitleClone.scrollLeft = sl
      }
    },
    // 反向横滚同步：fixed clone.scrollLeft → wrapper.scrollLeft
    syncWrapperFromClone() {
      if (this.isHeaderFixed && this._headerClone && this.$refs.tableWrapper) {
        this.$refs.tableWrapper.scrollLeft = this._headerClone.scrollLeft
      }
    },
    // 分组标题吸顶：表头 fixed 后，当前可见分组的标题固定在表头下方（136px）
    fixGroupTitleIfNeeded() {
      const tw = this.$refs.tableWrapper
      if (!tw || !this.isHeaderFixed) {
        this._removeGroupTitleClone()
        return
      }
      const FIX_TOP = 158 // 112（标题+导航）+ 46（表头）
      const twRect = tw.getBoundingClientRect()
      const groups = this.groupRefs
      let targetRow = null
      let targetIdx = -1
      // 找当前可见区域内需要吸顶的分组标题
      for (let i = 0; i < groups.length; i++) {
        const group = groups[i]
        if (!group) continue
        const groupRect = group.getBoundingClientRect()
        // 分组底部仍在 FIX_TOP 以下（未完全滚出），且分组顶部已滚到 FIX_TOP 以上
        if (groupRect.bottom > FIX_TOP + 10 && groupRect.top <= FIX_TOP) {
          const titleRow = group.querySelector('.group-title-row')
          if (titleRow) {
            targetRow = titleRow
            targetIdx = i
            break
          }
        }
      }
      if (targetRow && targetIdx !== this.currentFixedGroupIndex) {
        this._removeGroupTitleClone()
        targetRow.style.visibility = 'hidden'
        const clone = targetRow.cloneNode(true)
        clone.style.cssText = `position:fixed;top:${FIX_TOP}px;left:${twRect.left}px;width:${tw.clientWidth}px;z-index:8;overflow-x:auto;overflow-y:hidden;display:block;visibility:visible;`
        clone.scrollLeft = tw.scrollLeft
        const onCloneScroll = () => {
          if (this.$refs.tableWrapper) {
            this.$refs.tableWrapper.scrollLeft = clone.scrollLeft
          }
        }
        clone.addEventListener('scroll', onCloneScroll)
        clone._onScroll = onCloneScroll
        document.body.appendChild(clone)
        this._groupTitleClone = clone
        this._groupTitleOrigin = targetRow
        this.currentFixedGroupIndex = targetIdx
      } else if (!targetRow) {
        this._removeGroupTitleClone()
      } else if (
        targetRow &&
        targetIdx === this.currentFixedGroupIndex &&
        this._groupTitleClone
      ) {
        this._groupTitleClone.style.left = twRect.left + 'px'
        this._groupTitleClone.style.width = tw.clientWidth + 'px'
      }
      // 同步横滚
      if (this._groupTitleClone && tw) {
        this._groupTitleClone.scrollLeft = tw.scrollLeft
      }
    },
    _removeGroupTitleClone() {
      if (this._groupTitleClone) {
        if (this._groupTitleClone._onScroll) {
          this._groupTitleClone.removeEventListener(
            'scroll',
            this._groupTitleClone._onScroll
          )
        }
        this._groupTitleClone.remove()
        this._groupTitleClone = null
      }
      if (this._groupTitleOrigin) {
        this._groupTitleOrigin.style.visibility = ''
        this._groupTitleOrigin = null
      }
      this.currentFixedGroupIndex = -1
    },
    setGroupRef(el, index) {
      if (el) this.groupRefs[index] = el
    },
    // 点击左侧导航 → 右侧滚动到对应分组
    scrollToGroup(index) {
      this.activeIndex = index
      const target = this.groupRefs[index]
      if (!target) return
      const container = this.$refs.rightContent
      const isMobile = window.innerWidth <= 768
      if (isMobile) {
        // 标题62 + 导航50 + 表头46 = 158
        const targetRect = target.getBoundingClientRect()
        const stickyHeight = 158
        window.scrollTo({
          top: targetRect.top + window.pageYOffset - stickyHeight,
          behavior: 'smooth',
        })
        return
      }
      // 桌面端：精确滚动 right-content 容器
      const containerRect = container.getBoundingClientRect()
      const targetRect = target.getBoundingClientRect()
      const scrollOffset =
        targetRect.top - containerRect.top + container.scrollTop - 46
      container.scrollTo({
        top: scrollOffset,
        behavior: 'smooth',
      })
    },
    async modelParameterFn() {
      const {
        data: { data = [] },
      } = await modelPropParameterApi({ id: this.id })
      console.log('data', data)

      const titleMap = {
        10001: 'Vehicle Parameters',
        10002: 'Exterior Features',
        10003: 'Interior Features',
        10004: 'Convenience & Safety Features',
      }
      const titleMap2 = {
        10001: '车辆参数',
        10002: '外观配置',
        10003: '内饰配置',
        10004: '舒适安全配置',
      }

      const categoryMap = new Map()

      const versions = Object.keys(data).sort((a, b) => Number(a) - Number(b))

      for (const ver of versions) {
        const vKey = `v${ver}`
        const items = data[ver]
        if (!Array.isArray(items)) continue

        for (const item of items) {
          const {
            propt_id,
            prop_nameEn: name,
            prop_name,
            prop_valCttEn: value,
          } = item
          // console.log('item :>> ', item)

          if (!categoryMap.has(propt_id)) {
            categoryMap.set(propt_id, new Map())
          }
          const nameMap = categoryMap.get(propt_id)

          if (!nameMap.has(name)) {
            const obj = { name, t: { en: name, zh: prop_name } }
            for (const v of versions) {
              obj[`v${v}`] = ''
            }
            nameMap.set(name, obj)
          }

          const target = nameMap.get(name)
          target[vKey] = value
        }
      }

      const result = []
      for (const [proptId, nameMap] of categoryMap.entries()) {
        const title = titleMap[proptId]
        const title2 = titleMap2[proptId]
        if (!title) continue
        const items = Array.from(nameMap.values())
        result.push({ title, t: { en: title, zh: title2 }, items })
      }
      this.vehicleConfig = result
      console.log('vehicleConfig', this.vehicleConfig)
    },
    langShow(p) {
      // console.log('object :>> ------------------', p)
      if (!p) {
        return ''
      }
      return p[this.$i18n.locale]
    },
  },
}
</script>

<style lang="scss" scoped>
.contaier {
  .title-area {
    // padding-top: 140px;
  }
  .max-box {
    .hq-title1 {
      // padding: 60px 0;
      font-size: 32px;
    }
    .attentions {
      display: flex;
      justify-content: center;
      align-items: center;
      .iconspan {
        padding-left: 5px;
        padding-right: 15px;
      }
    }
  }
}
/* 整体布局 */
.config-page-container {
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin: 30px auto;
  padding: 0 20px;
  gap: 20px;
}

/* ========== 左侧导航 ========== */
.left-nav {
  display: flex;
  flex-direction: column;
  width: 200px;
  flex-shrink: 0;
  position: sticky;
  top: 30px;
  height: fit-content;
  margin-bottom: 0;
  overflow: hidden;
  font-weight: 600;
  border: 1px solid #e5e5e5;
}
.nav-item {
  padding: 14px 12px;
  text-align: left;
  font-size: 14px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  color: #333;
  background: #fff;
}

.nav-item.active {
  background: #24308f;
  font-weight: 600;
  color: #fff;
}
.nav-item:hover:not(.active) {
  background: #f0f3ff;
}

/* ========== 右侧内容 ========== */
.right-content {
  flex: 1;
  max-height: 680px;
  overflow-y: auto;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
  border: 1px solid #e5e5e5;
}

/* 滚动条美化 */
.right-content::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.right-content::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 3px;
}

/* ========== 表头吸顶 ========== */
.table-header-sticky {
  position: sticky;
  top: 0;
  z-index: 99;
  background: #f7f7f7;
}

/* ========== 分组标题（grid-row，第一列 sticky 和 name-cell 一致） ========== */
.group-title-row {
  position: sticky;
  top: 46px; /* 表头高度 */
  z-index: 90;
  background: #f2f2f2;
}
.group-title-row .cell {
  background: #f2f2f2;
}
.group-title-cell {
  font-weight: bold;
  text-align: left;
}

/* ========== 网格布局 ========== */
.grid-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 1fr;
  border-bottom: 1px solid #f0f0f0;
  .cell-top {
    z-index: 999;
    // z-index: 99999999;
  }
}
.cell {
  padding: 14px 8px;
  text-align: center;
  font-size: 14px;
  color: #333;
  border-right: 1px solid #f0f0f0;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}
.cell:last-child {
  border-right: none;
}

.name-cell {
  text-align: left;
  padding-left: 16px;
  word-break: break-word;
  overflow-wrap: break-word;
  position: sticky;
  left: 0;
  z-index: 2;
  background: #fff;
}

/* 高亮车型列 */
/* .cell.active {
  background: #edf2fa;
  font-weight: 500;
} */

/* 表头文字 */
.table-header-sticky .cell {
  font-weight: bold;
  padding: 12px 8px;
}
.table-header-sticky .name-cell {
  background: #f7f7f7;
  z-index: 98;
}
/* .table-header-sticky .cell.active {
  background: #004c9c;
  color: #fff;
} */
.table-header-sticky .cell span {
  background: #ff6d00;
  color: #fff;
  padding: 1px 4px;
  border-radius: 2px;
  font-size: 12px;
  margin-top: 3px;
  display: inline-block;
}

/* 分组间隔 */
.group-item + .group-item {
  border-top: 1px solid #eee;
}

/* ========== 移动端适配 ========== */
@media (max-width: 768px) {
  .contaier {
    // padding-top: 80px;
    .title-area {
      // padding-top: 140px;
      // padding-bottom: 40px;
    }
    /* 不设 overflow-x，让页面自然横向滚动，sticky 才能直通视口 */
  }

  /* 标题区域 */
  .title-area {
    // padding-top: 80px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    background: #fff;
    max-width: 100%;
    margin: 0;
    box-sizing: border-box;
  }

  .config-page-container {
    flex-direction: column;
    padding: 10px 6px 0;
    margin: 0 auto;
    gap: 10px;
  }

  /* 导航条 */
  .left-nav {
    position: fixed;
    top: 62px;
    left: 0;
    right: 0;
    z-index: 99;
    background: #fff;
    width: 100%;
    max-width: 100%;
    margin: 0;
    box-sizing: border-box;
    border: none;
    padding: 4px 0;
  }

  .nav-scroll {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
    width: 100%;
  }

  .nav-item {
    padding: 14px 16px;
    font-size: 12px;
    white-space: nowrap;
    text-align: center;
    flex-shrink: 0;
    border-bottom: 2px solid transparent;
    border-right: none;
  }

  .nav-item.active {
    border-bottom: 2px solid #24308f;
    background: transparent;
    color: #24308f;
  }

  /* right-content 不做滚动容器，清除 relative 避免干扰 sticky */
  .right-content {
    max-height: none;
    overflow: visible;
    border: none;
    flex: none;
    width: 100%;
    position: static;
  }

  /* table-wrapper 横向滚动容器 → sticky left:0 生效；竖向吸顶由 JS 接管 */
  .table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
  }

  /* 表头 - JS 控制 position:fixed 实现竖向吸顶；横向 sticky-left 保持 */
  .table-header-sticky {
    position: static;
    z-index: 10;
    background: #f7f7f7;
  }
  /* 表头常规列（Executive/Deluxe等）重置为 static */
  .table-header-sticky .cell:not(.name-cell) {
    position: static;
    padding: 12px 6px;
  }
  /* 表头第一列 sticky-left（写在 .cell 规则之后，确保不被覆盖） */
  .table-header-sticky .cell.name-cell {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    background: #f7f7f7;
    z-index: 11;
    padding: 14px 8px;
  }

  /* 分组标题行 - grid-row 融入表格，第一列 sticky-left 天然继承 name-cell */
  .group-title-row {
    top: auto;
    background: #f2f2f2;
  }
  .group-title-row .cell {
    background: #f2f2f2;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #f0f0f0;
  }
  .group-title-cell {
    z-index: 3;
    font-weight: bold;
    font-size: 12px;
    text-align: left;
  }

  /* 表格最小宽度保证内容不挤压变形 */
  .grid-row,
  .group-list {
    min-width: 520px;
  }

  .grid-row {
    // padding-top: 110px;
    grid-template-columns: 150px 1fr 1fr 1fr 1fr;
  }

  .group-title-row {
    grid-template-columns: 350px 1fr 1fr 1fr 1fr;
  }

  .cell {
    padding: 12px 8px;
    font-size: 12px;
  }

  .name-cell {
    padding-left: 12px;
    position: sticky;
    left: 0;
    z-index: 2;
    background: #fff;
  }
  .cell-top {
    // z-index: 99 !important;
    z-index: 9999999999 !important;
  }
  /* 标题紧凑 */
  .contaier .title-area .hq-title1 {
    font-size: 18px;
    padding: 8px 0 4px;
  }

  .contaier .title-area .attentions {
    flex-wrap: wrap;
    font-size: 11px;
    padding-bottom: 6px;
  }
}
</style>
